import type { Region, Retailer } from '@vizit/api';

// Typed as Retailer[]/Region[] so TypeScript errors if the API spec adds new values.
const VALID_RETAILERS: readonly Retailer[] = ['amazon', 'walmart'];
const VALID_REGIONS: readonly Region[] = [
  'us',
  'uk',
  'de',
  'fr',
  'es',
  'it',
  'ca',
  'mx',
  'jp',
  'au',
  'in',
  'br',
  'sg',
  'nl',
  'se',
  'pl',
  'be',
  'tr',
];

export function isRetailer(value: string): value is Retailer {
  return (VALID_RETAILERS as readonly string[]).includes(value);
}

export function isRegion(value: string): value is Region {
  return (VALID_REGIONS as readonly string[]).includes(value);
}
